<mat-card class="card">
  <mat-card-content class="content">
    <mat-icon svgIcon="cumulative-test-create" class="icon"></mat-icon>
    <div class="text button">CREATE NEW TOPIC TEST</div>
  </mat-card-content>
</mat-card>
